import React from 'react';
export function SampleTag({
  label = 'Sample listing',
  className = ''
}: {
  label?: string;
  className?: string;
}) {
  return <span className={`inline-flex items-center rounded border border-gold/50 bg-gold-100 px-2 py-0.5 text-[11px] font-medium text-gold-700 ${className}`} data-id="element-545" data-mp="3nk1qvkzqfo5">
      {label}
    </span>;
}